import { useRef } from 'react';
import ReactPhoneInput2 from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useDynamicField } from '../core/useDynamicField';
import { FormName } from '../core/formRegistry';
import { Wrapper, Label, PhoneContainer, PostButton, ErrorBubble } from './CustomPhoneInput.style';

type TPhoneInputProps = {
    formName: FormName;
    field: string;
    label: string;
    required?: boolean;
    className?: string;
    disabled?: boolean;
    dataTestId?: string;
    inputProps?: object;
    postBtn?: boolean;
    onBtnClick?: () => void;
    onBlur?: () => void;
};

export const CustomPhoneInput = ({
    formName,
    field,
    label,
    required,
    className,
    disabled,
    dataTestId,
    inputProps,
    postBtn,
    onBtnClick,
    onBlur: customOnBlur,
}: TPhoneInputProps) => {
    const elementRef = useRef<HTMLDivElement>(null);
    const f = useDynamicField(formName, field);

    return (
        <Wrapper ref={elementRef} className={className} data-test-id={dataTestId || 'phone-input'}>
            <Label $required={!!required} htmlFor={(inputProps as { name: string })?.name || ''}>
                {label}
            </Label>

            <PhoneContainer $disabled={!!disabled}>
                <ReactPhoneInput2
                    preferredCountries={['us']}
                    country={'us'}
                    value={f.value}
                    onChange={(value) => (
                        f.onChange(`+${value}`),
                        (
                            elementRef.current?.querySelector('.form-control') as HTMLInputElement
                        )?.focus()
                    )}
                    onBlur={() => {
                        f.onBlur();
                        customOnBlur?.();
                    }}
                    countryCodeEditable={true}
                    inputProps={inputProps}
                    disabled={disabled}
                    containerStyle={{
                        height: '100%',
                        width: '100%',
                    }}
                    inputStyle={{
                        borderRadius: '24px',
                    }}
                    buttonStyle={{
                        left: '16px',
                        borderRadius: '16px',
                    }}
                />
            </PhoneContainer>

            {postBtn && <PostButton onClick={onBtnClick}>＋</PostButton>}

            {f.touched && f.error && <ErrorBubble>{f.error}</ErrorBubble>}
        </Wrapper>
    );
};
